export default function BrandLogo({ size = 'default', darkBg = false, className = '' }) {
  const imgSizes = { sm: 'h-12', default: 'h-16', lg: 'h-20', xl: 'h-28' };

  // darkBg=true: show original logo (light text on dark bg)
  // darkBg=false: in dark mode show original, in light mode apply brightness-0 (black)
  const filterClass = darkBg ? '' : 'dark:brightness-100 brightness-0';

  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src="/icons/torq-logo.png"
        alt="TORQ"
        className={`${imgSizes[size]} w-auto object-contain ${filterClass}`}
      />
    </div>
  );
}
